import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "./auth/AdminLogin";
import ProtectedAdminRoute from "./auth/ProtectedAdminRoute";
import AdminLayout from "./AdminLayout";
import GlobalPricing from "./screens/GlobalPricing";
import GroupPricing from "./screens/GroupPricing";
import UserPricing from "./screens/UserPricing";
import CityManage from "./screens/CityManage";
import VatManage from "./screens/VatManage";
import Hotels from "./screens/Hotels";
import HotelEditor from "./screens/HotelEditor";

// Standalone route tree for the admin console. Rendered by App outside the
// site's MainRoute, so it has no site Header/Footer and no WP-redirect auth.
const AdminApp = () => {
  return (
    <Routes>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedAdminRoute>
            <AdminLayout />
          </ProtectedAdminRoute>
        }
      >
        <Route index element={<Navigate to="global-pricing" replace />} />
        <Route path="global-pricing" element={<GlobalPricing />} />
        <Route path="group-pricing" element={<GroupPricing />} />
        <Route path="user-pricing" element={<UserPricing />} />
        <Route path="city-manage" element={<CityManage />} />
        <Route path="vat-manage" element={<VatManage />} />
        <Route path="hotels" element={<Hotels />} />
        <Route path="hotels/new" element={<HotelEditor />} />
        <Route path="hotels/:id" element={<HotelEditor />} />
      </Route>
      <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};

export default AdminApp;
